import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";

function Deleteresume(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        show={props.show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <img
            onClick={props.hide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            <div className="text-center">
              <img src="/images/pro_img.png" />
              <h4 className="maintitle deletetitle">Warning !</h4>
              <p className="titledesc deletedesc">
                You are Migrating to a New Template, You may not able to revert
                back to this Template!
              </p>
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  onClick={props.showTemplatePopup}
                  className="btn primarybtn  bgsuccess text-white mainborder float-right   p-14 w-75 delbtn"
                >
                  Change Template
                </button>
              </div>
              <div className="col-md-6">
                <button
                  onClick={props.hide}
                  className="btn primarybtn  w-75 mainborder delbtn position-relative"
                >
                  <span className="resume-options">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Deleteresume;
